import { Translation } from 'primeng/api';
import { translateLangToAngularDateLocale } from './translate-date-locale';
import { PRIME_NG_EN_CALENDAR } from '../i18n/prime-ng-default-en-calendar';

/**
 * Build PrimeNG `Translation` fields used by p-calendar (month/day labels, etc.) from
 * the active app language, using the Intl API. English restores the default PrimeNG copy.
 */
export function buildPrimeNgCalendarTranslation(
  translateLang: string | null | undefined,
  buttonLabels: { today: string; clear: string }
): Partial<Translation> {
  const t = translateLang || 'en';
  if (t === 'en') {
    return {
      ...PRIME_NG_EN_CALENDAR,
      today: buttonLabels.today,
      clear: buttonLabels.clear,
    };
  }

  const loc = translateLangToAngularDateLocale(translateLang);
  const dayNames: string[] = [];
  const dayNamesShort: string[] = [];
  const dayNamesMin: string[] = [];
  // Jan 1, 2023 is a Sunday
  for (let i = 0; i < 7; i++) {
    const d = new Date(2023, 0, 1 + i);
    dayNames.push(
      new Intl.DateTimeFormat(loc, { weekday: 'long' }).format(d)
    );
    dayNamesShort.push(
      new Intl.DateTimeFormat(loc, { weekday: 'short' }).format(d)
    );
    dayNamesMin.push(
      new Intl.DateTimeFormat(loc, { weekday: 'narrow' }).format(d)
    );
  }
  const monthNames: string[] = [];
  const monthNamesShort: string[] = [];
  for (let m = 0; m < 12; m++) {
    const d = new Date(2023, m, 1);
    monthNames.push(new Intl.DateTimeFormat(loc, { month: 'long' }).format(d));
    monthNamesShort.push(
      new Intl.DateTimeFormat(loc, { month: 'short' }).format(d)
    );
  }

  let firstDayOfWeek = 0;
  try {
    const L = new Intl.Locale(loc);
    const wi = (L as any).getWeekInfo?.() ?? (L as any).weekInfo;
    if (wi && typeof wi.firstDay === 'number') {
      // weekInfo: 1=Mon … 7=Sun; PrimeNG: 0=Sun … 6=Sat
      const fd = wi.firstDay;
      firstDayOfWeek = fd % 7;
    }
  } catch {
    firstDayOfWeek = 0;
  }

  return {
    dayNames,
    dayNamesShort,
    dayNamesMin,
    monthNames,
    monthNamesShort,
    firstDayOfWeek,
    dateFormat: 'dd/mm/yy',
    today: buttonLabels.today,
    clear: buttonLabels.clear,
  };
}
